import React from "react";
import LinearProgress from "@mui/material/LinearProgress";

const DeterminateProgress = ({ value }) => {
  return (
    <LinearProgress
      variant="determinate"
      value={value}
      sx={{
        width: "100vw",
        height: "8px", // adjust height as needed
        backgroundColor: "#e0e0e0", // track color (optional)
        "& .MuiLinearProgress-bar": {
          backgroundColor: "#144A8C", // progress bar color
        },
      }}
    />
  );
};

export default DeterminateProgress;
